import { Component, OnInit } from '@angular/core';
import { BrowseobligorService } from '../services/browseobligor.service';
import { Browseobligor } from '../Models/browseobligor';
import { Router } from '@angular/router';
import { isBoolean, debug } from 'util';
declare function MagnifierONOFF(): any;
declare function responsiveVoiceSpeak(title, innerText): any;
declare function BrowseObligorsponsiveVoiceSpeak(placeholder, inputValue, keyCode, innerText, eventId, controlType, title, htmlFor, alt, key): any;
declare var $: any;
declare function browseobligorvoiceOnKeyPress(value, key, targetid): any;
declare function voiceForObligorCount(obligorCount): any;
declare function voiceForLastObligor(targetid): any;
declare const voiceForObligorNoFound: any;
declare const voiceForObligorSearch: any;
declare function FontSizeSettings(): any;
var IsLoadFontSizeSettings = 0;
//declare function FontSizeSettingsBrowseObligor(): any;

@Component({
  selector: 'app-browse-obligor',
  templateUrl: './browse-obligor.component.html',
  styleUrls: ['./browse-obligor.component.css'],
  providers: [BrowseobligorService]
})
export class BrowseObligorComponent implements OnInit {

  routeName: string;

  public allBrowseobligor: any;
  public AlphabeticalValue: string;
  constructor(private browseobligorService: BrowseobligorService, private router: Router) { }

  onkeypress(event, obligorId, obligorDesc, webcastsPresent) {
    debugger;
    // Enable/Disable search button on the Obligor Name Search Box (3 or more letters).
    if (event.target.id == "inputSuccess5") {
      var btnSearch = <HTMLButtonElement>document.getElementById("btnSearch");
      if ((event.target.value.length + event.key.length) == 3 || (event.target.value.length + event.key.length) > 3) {
        btnSearch.disabled = false;
      }
      else {
        btnSearch.disabled = true;
      }
    }

    if (event.keyCode == 27) {
      //if (event.target.id == "tdAlerts" || event.target.id == "tdobligorDesc" || event.target.id == "tdwebcasts" || event.target.id == "tdOverview" || event.target.id == "tdHistory" || event.target.id == "tdQA") {
        document.getElementById("SkipMainContentfooter").focus();
        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("SkipMainContentfooter").innerText, document.getElementById("SkipMainContentfooter").id, event.target.type, document.getElementById("SkipMainContentfooter").title, event.target.htmlFor, event.target.alt, event.key);
      //}
      return;
    }

    //Set value for obligorId and obligorDesc for all components.
    if (event.target.id == "inputSuccess5") {
      if (event.keyCode != 17 && event.keyCode != 0) {
        browseobligorvoiceOnKeyPress(event.target.value, event.key, event.target.id);
      }
    }
    else if (event.target.id == "tdwebcasts" && event.keyCode == 13) {
      localStorage.clear();
      localStorage.OBLIGOR_ID = obligorId;
      localStorage.OBLIGOR_DESC = obligorDesc;
      if (webcastsPresent == true) {
        this.router.navigate(['/Accessingwebcasts']);
      }
      else {
        BrowseObligorsponsiveVoiceSpeak("", "", 39, false, "tdwebcasts", "", false, "", "", "");
      }
    }
    else if (event.target.id == "tdOverview" && event.keyCode == 13) {
      //localStorage.clear();
      localStorage.OBLIGOR_ID = obligorId;
      localStorage.OBLIGOR_DESC = obligorDesc;
      this.router.navigate(['/investor-browse-borrowing-documents']);
    }
    else if (event.target.id == "tdHistory" && event.keyCode == 13) {
      //localStorage.clear();
      localStorage.OBLIGOR_ID = obligorId;
      localStorage.OBLIGOR_DESC = obligorDesc;
      this.router.navigate(['/investor-browse-filing-types']);
    }
    else if (event.target.id == "tdQA" && event.keyCode == 13) {
      localStorage.clear();
      localStorage.OBLIGOR_ID = obligorId;
      localStorage.OBLIGOR_DESC = obligorDesc;
      this.router.navigate(['/ask-aquestion']);
    }
    else if (event.keyCode == 32) {
      if (event.target.id == "btnClear" || event.target.id == "btnSearch") {
        event.preventDefault();
        return;
      }      
    }
  };
  onKeyUp(event: any, obligorId, obligorDesc, webcastsPresent) {
    debugger;    
    if (event.target.id == "lblobligorTableMsg" && event.keyCode == 9) {
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("tblPagebrowseObligar").innerText, "tblPagebrowseObligar", event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
      //document.getElementById("tblPagebrowseObligar").focus();
      return;
    }

    if (event.target.id == "tblPagebrowseObligar" && event.keyCode == 9) {      
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("tdobligorDesc").innerText, "tdobligorDesc", event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);      
      document.getElementById("tdobligorDesc").focus();
      return;
    }

    if ((event.target.id == "tdobligorDesc" || event.target.id == "tdwebcasts" || event.target.id == "tdAlerts" || event.target.id == "tdOverview" || event.target.id == "tdHistory" || event.target.id == "tdQA") && (event.keyCode == 9)) {
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, event.target.innerText, event.target.id, event.target.type, "", event.target.htmlFor, event.target.alt, event.key);
      event.preventDefault();
      return;
    }

    if (event.target.id == "tdAlerts" && event.keyCode == 32 && event.ctrlKey == true) {
      event.preventDefault();
      return;
    }
    if (event.target.id == "btnClear" && event.keyCode == 9) {
      var inputSearch = <HTMLInputElement>document.getElementById("inputSuccess5");
      var buttonSearch = <HTMLButtonElement>document.getElementById("btnSearch");
      if (inputSearch.value.length > 0 && buttonSearch.disabled == true) {
        document.getElementById("inputSuccess5").focus();
        voiceForObligorSearch();
        return;
      }
    }

    // Enable/Disable search button on the Obligor Name Search Box (3 or more letters).
    if (event.target.id == "inputSuccess5") {
      var btnSearch = <HTMLButtonElement>document.getElementById("btnSearch");
      if (event.target.value.length == 3 || event.target.value.length > 3) {
        btnSearch.disabled = false;
      }
      else {
        btnSearch.disabled = true;
      }
    }

    if ((event.target.id == "lblAlphabeticalFilter" || event.target.id == "lblobligorTableMsg") && (event.keyCode == 9 || event.keyCode == 16)) {
      document.getElementById("AID").tabIndex = 26;
      document.getElementById("BID").tabIndex = -1;
      document.getElementById("CID").tabIndex = -1;
      document.getElementById("DID").tabIndex = -1;
      document.getElementById("EID").tabIndex = -1;
      document.getElementById("FID").tabIndex = -1;
      document.getElementById("GID").tabIndex = -1;
      document.getElementById("HID").tabIndex = -1;
      document.getElementById("IID").tabIndex = -1;
      document.getElementById("JID").tabIndex = -1;
      document.getElementById("KID").tabIndex = -1;
      document.getElementById("LID").tabIndex = -1;
      document.getElementById("MID").tabIndex = -1;
      document.getElementById("NID").tabIndex = -1;
      document.getElementById("OID").tabIndex = -1;
      document.getElementById("PID").tabIndex = -1;
      document.getElementById("QID").tabIndex = -1;
      document.getElementById("RID").tabIndex = -1;
      document.getElementById("SID").tabIndex = -1;
      document.getElementById("TID").tabIndex = -1;
      document.getElementById("UID").tabIndex = -1;
      document.getElementById("VID").tabIndex = -1;
      document.getElementById("WID").tabIndex = -1;
      document.getElementById("XID").tabIndex = -1;
      document.getElementById("YID").tabIndex = -1;
      document.getElementById("ZID").tabIndex = -1;
    }

    if (event.target.id == "tdobligorDesc" && event.keyCode == 13) {      
      localStorage.setItem("OBLIGOR_ID", obligorId);
      this.router.navigate(['/compliance-review']);
      return;
    }

    if (event.target.id == "tdObligorState" && event.keyCode == 13) {
      localStorage.setItem("OBLIGOR_ID", obligorId);
      this.router.navigate(['/compliance-review']);
      return;
    }

    if (event.target.id == "tdOverview" && event.keyCode == 13) {
      localStorage.OBLIGOR_ID = obligorId;
      localStorage.OBLIGOR_DESC = obligorDesc;
      this.router.navigate(['/investor-browse-borrowing-documents']);
      return;
    }
    if (event.target.id == "tdHistory" && event.keyCode == 13) {      
      localStorage.OBLIGOR_ID = obligorId;
      localStorage.OBLIGOR_DESC = obligorDesc;
      this.router.navigate(['/investor-browse-filing-types']);
      return;
    }
    if (event.target.id == "tdQA" && event.keyCode == 13) {      
      localStorage.OBLIGOR_ID = obligorId;
      localStorage.OBLIGOR_DESC = obligorDesc;
      this.router.navigate(['/ask-aquestion']);
      return;
    }
    if (event.keyCode != 17) {
      debugger;
      var child_cell = $(event.target).index();
      if (event.keyCode == 38) {
        this.UpArrowKey(event, child_cell);
        return;
      }
      else if (event.keyCode == 40) {
        debugger;
        this.DownArrowKey(event);       
        return;
      }
      else if (event.keyCode == 39) {
        debugger;
        this.RightArrowKey(event, child_cell);
        if (event.target.id == "AID") {
          document.getElementById("BID").tabIndex = event.target.tabIndex;
          document.getElementById("BID").focus();
          this.TabbingAlphabeticalFilter("BID");
          this.AlphabeticalValue = "BID";//this.loadBrowseObligors(document.getElementById("BID").innerText);
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("BID").innerText, document.getElementById("BID").id, event.target.type, document.getElementById("BID").title, event.target.htmlFor, event.target.alt, event.key);

        }
        if (event.target.id == "BID") {
          document.getElementById("CID").tabIndex = event.target.tabIndex;
          document.getElementById("CID").focus();
          this.TabbingAlphabeticalFilter("CID");
          this.AlphabeticalValue = "CID";
         // this.loadBrowseObligors(document.getElementById("CID").innerText);
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("CID").innerText, document.getElementById("CID").id, event.target.type, document.getElementById("CID").title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (event.target.id == "CID") {
          document.getElementById("DID").tabIndex = event.target.tabIndex;
          document.getElementById("DID").focus();
          this.TabbingAlphabeticalFilter("DID");
          this.AlphabeticalValue = "DID";
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("DID").innerText, document.getElementById("DID").id, event.target.type, document.getElementById("DID").title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (event.target.id == "DID") {
          document.getElementById("EID").tabIndex = event.target.tabIndex;
          document.getElementById("EID").focus();
          this.TabbingAlphabeticalFilter("EID");
          this.AlphabeticalValue = "EID";
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("EID").innerText, document.getElementById("EID").id, event.target.type, document.getElementById("EID").title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (event.target.id == "EID") {
          document.getElementById("FID").tabIndex = event.target.tabIndex;
          document.getElementById("FID").focus();
          this.TabbingAlphabeticalFilter("FID");
          this.AlphabeticalValue = "FID";
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("FID").innerText, document.getElementById("FID").id, event.target.type, document.getElementById("FID").title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (event.target.id == "FID") {
          document.getElementById("GID").tabIndex = event.target.tabIndex;
          document.getElementById("GID").focus();
          this.TabbingAlphabeticalFilter("GID");
          this.AlphabeticalValue = "GID";
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("GID").innerText, document.getElementById("GID").id, event.target.type, document.getElementById("GID").title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (event.target.id == "GID") {
          document.getElementById("HID").tabIndex = event.target.tabIndex;
          document.getElementById("HID").focus();
          this.TabbingAlphabeticalFilter("HID");
          this.AlphabeticalValue = "HID";
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("HID").innerText, document.getElementById("HID").id, event.target.type, document.getElementById("HID").title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (event.target.id == "HID") {
          document.getElementById("IID").tabIndex = event.target.tabIndex;
          document.getElementById("IID").focus();
          this.TabbingAlphabeticalFilter("IID");
          this.AlphabeticalValue = "IID";
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("IID").innerText, document.getElementById("IID").id, event.target.type, document.getElementById("IID").title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (event.target.id == "IID") {
          document.getElementById("JID").tabIndex = event.target.tabIndex;
          document.getElementById("JID").focus();
          this.TabbingAlphabeticalFilter("JID");
          this.AlphabeticalValue = "JID";
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("JID").innerText, document.getElementById("JID").id, event.target.type, document.getElementById("JID").title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (event.target.id == "JID") {
          document.getElementById("KID").tabIndex = event.target.tabIndex;
          document.getElementById("KID").focus();
          this.TabbingAlphabeticalFilter("KID");
          this.AlphabeticalValue = "KID";
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("KID").innerText, document.getElementById("KID").id, event.target.type, document.getElementById("KID").title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (event.target.id == "KID") {
          document.getElementById("LID").tabIndex = event.target.tabIndex;
          document.getElementById("LID").focus();
          this.TabbingAlphabeticalFilter("LID");
          this.AlphabeticalValue = "LID";
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("LID").innerText, document.getElementById("LID").id, event.target.type, document.getElementById("LID").title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (event.target.id == "LID") {
          document.getElementById("MID").tabIndex = event.target.tabIndex;
          document.getElementById("MID").focus();
          this.TabbingAlphabeticalFilter("MID");
          this.AlphabeticalValue = "MID";
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("MID").innerText, document.getElementById("MID").id, event.target.type, document.getElementById("MID").title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (event.target.id == "MID") {
          document.getElementById("NID").tabIndex = event.target.tabIndex;
          document.getElementById("NID").focus();
          this.TabbingAlphabeticalFilter("NID");
          this.AlphabeticalValue = "NID";
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("NID").innerText, document.getElementById("NID").id, event.target.type, document.getElementById("NID").title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (event.target.id == "NID") {
          document.getElementById("OID").tabIndex = event.target.tabIndex;
          document.getElementById("OID").focus();
          this.TabbingAlphabeticalFilter("OID");
          this.AlphabeticalValue = "OID";
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("OID").innerText, document.getElementById("OID").id, event.target.type, document.getElementById("OID").title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (event.target.id == "OID") {
          document.getElementById("PID").tabIndex = event.target.tabIndex;
          document.getElementById("PID").focus();
          this.TabbingAlphabeticalFilter("PID");
          this.AlphabeticalValue = "PID";
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("PID").innerText, document.getElementById("PID").id, event.target.type, document.getElementById("PID").title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (event.target.id == "PID") {
          document.getElementById("QID").tabIndex = event.target.tabIndex;
          document.getElementById("QID").focus();
          this.TabbingAlphabeticalFilter("QID");
          this.AlphabeticalValue = "QID";
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("QID").innerText, document.getElementById("QID").id, event.target.type, document.getElementById("QID").title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (event.target.id == "QID") {
          document.getElementById("RID").tabIndex = event.target.tabIndex;
          document.getElementById("RID").focus();
          this.TabbingAlphabeticalFilter("RID");
          this.AlphabeticalValue = "RID";
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("RID").innerText, document.getElementById("RID").id, event.target.type, document.getElementById("RID").title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (event.target.id == "RID") {
          document.getElementById("SID").tabIndex = event.target.tabIndex;
          document.getElementById("SID").focus();
          this.TabbingAlphabeticalFilter("SID");
          this.AlphabeticalValue = "SID";
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("SID").innerText, document.getElementById("SID").id, event.target.type, document.getElementById("SID").title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (event.target.id == "SID") {
          document.getElementById("TID").tabIndex = event.target.tabIndex;
          document.getElementById("TID").focus();
          this.TabbingAlphabeticalFilter("TID");
          this.AlphabeticalValue = "TID";
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("TID").innerText, document.getElementById("TID").id, event.target.type, document.getElementById("TID").title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (event.target.id == "TID") {
          document.getElementById("UID").tabIndex = event.target.tabIndex;
          document.getElementById("UID").focus();
          this.TabbingAlphabeticalFilter("UID");
          this.AlphabeticalValue = "UID";
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("UID").innerText, document.getElementById("UID").id, event.target.type, document.getElementById("UID").title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (event.target.id == "UID") {
          document.getElementById("VID").tabIndex = event.target.tabIndex;
          document.getElementById("VID").focus();
          this.TabbingAlphabeticalFilter("VID");
          this.AlphabeticalValue = "VID";
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("VID").innerText, document.getElementById("VID").id, event.target.type, document.getElementById("VID").title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (event.target.id == "VID") {
          document.getElementById("WID").tabIndex = event.target.tabIndex;
          document.getElementById("WID").focus();
          this.TabbingAlphabeticalFilter("WID");
          this.AlphabeticalValue = "WID";
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("WID").innerText, document.getElementById("WID").id, event.target.type, document.getElementById("WID").title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (event.target.id == "WID") {
          document.getElementById("XID").tabIndex = event.target.tabIndex;
          document.getElementById("XID").focus();
          this.TabbingAlphabeticalFilter("XID");
          this.AlphabeticalValue = "XID";
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("XID").innerText, document.getElementById("XID").id, event.target.type, document.getElementById("XID").title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (event.target.id == "XID") {
          document.getElementById("YID").tabIndex = event.target.tabIndex;
          document.getElementById("YID").focus();
          this.TabbingAlphabeticalFilter("YID");
          this.AlphabeticalValue = "YID";
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("YID").innerText, document.getElementById("YID").id, event.target.type, document.getElementById("YID").title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (event.target.id == "YID") {
          document.getElementById("ZID").tabIndex = event.target.tabIndex;
          document.getElementById("ZID").focus();
          this.TabbingAlphabeticalFilter("ZID");
          this.AlphabeticalValue = "ZID";
          
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("ZID").innerText, document.getElementById("ZID").id, event.target.type, document.getElementById("ZID").title, event.target.htmlFor, event.target.alt, event.key);
        }
        //document.getElementById("ZID").innerText
      }
      else if (event.keyCode == 37) {

        this.LeftArrowKey(event, child_cell);

        if (event.target.id == "BID") {
          debugger;
          document.getElementById("AID").tabIndex = event.target.tabIndex;
          document.getElementById("AID").focus();
          this.TabbingAlphabeticalFilter("AID");
          this.AlphabeticalValue = "AID";
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("AID").innerText, document.getElementById("AID").id, event.target.type, document.getElementById("AID").title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (event.target.id == "CID") {
          document.getElementById("BID").tabIndex = event.target.tabIndex;
          document.getElementById("BID").focus();
          this.TabbingAlphabeticalFilter("BID");
          this.AlphabeticalValue = "BID";
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("BID").innerText, document.getElementById("BID").id, event.target.type, document.getElementById("BID").title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (event.target.id == "DID") {
          document.getElementById("CID").tabIndex = event.target.tabIndex;
          document.getElementById("CID").focus();
          this.TabbingAlphabeticalFilter("CID");
          this.AlphabeticalValue = "CID";
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("CID").innerText, document.getElementById("CID").id, event.target.type, document.getElementById("CID").title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (event.target.id == "EID") {
          document.getElementById("DID").tabIndex = event.target.tabIndex;
          document.getElementById("DID").focus();
          this.TabbingAlphabeticalFilter("DID");
          this.AlphabeticalValue = "DID";
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("DID").innerText, document.getElementById("DID").id, event.target.type, document.getElementById("DID").title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (event.target.id == "FID") {
          document.getElementById("EID").tabIndex = event.target.tabIndex;
          document.getElementById("EID").focus();
          this.TabbingAlphabeticalFilter("EID");
          this.AlphabeticalValue = "EID";
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("EID").innerText, document.getElementById("EID").id, event.target.type, document.getElementById("EID").title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (event.target.id == "GID") {
          document.getElementById("FID").tabIndex = event.target.tabIndex;
          document.getElementById("FID").focus();
          this.TabbingAlphabeticalFilter("FID");
          this.AlphabeticalValue = "FID";
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("FID").innerText, document.getElementById("FID").id, event.target.type, document.getElementById("FID").title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (event.target.id == "HID") {
          document.getElementById("GID").tabIndex = event.target.tabIndex;
          document.getElementById("GID").focus();
          this.TabbingAlphabeticalFilter("GID");
          this.AlphabeticalValue = "GID";
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("GID").innerText, document.getElementById("GID").id, event.target.type, document.getElementById("GID").title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (event.target.id == "IID") {
          document.getElementById("HID").tabIndex = event.target.tabIndex;
          document.getElementById("HID").focus();
          this.TabbingAlphabeticalFilter("HID");
          this.AlphabeticalValue = "HID";
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("HID").innerText, document.getElementById("HID").id, event.target.type, document.getElementById("HID").title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (event.target.id == "JID") {
          document.getElementById("IID").tabIndex = event.target.tabIndex;
          document.getElementById("IID").focus();
          this.TabbingAlphabeticalFilter("IID");
          this.AlphabeticalValue = "IID";
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("IID").innerText, document.getElementById("IID").id, event.target.type, document.getElementById("IID").title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (event.target.id == "KID") {
          document.getElementById("JID").tabIndex = event.target.tabIndex;
          document.getElementById("JID").focus();
          this.TabbingAlphabeticalFilter("JID");
          this.AlphabeticalValue = "JID";
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("JID").innerText, document.getElementById("JID").id, event.target.type, document.getElementById("JID").title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (event.target.id == "LID") {
          document.getElementById("KID").tabIndex = event.target.tabIndex;
          document.getElementById("KID").focus();
          this.TabbingAlphabeticalFilter("KID");
          this.AlphabeticalValue = "KID";
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("KID").innerText, document.getElementById("KID").id, event.target.type, document.getElementById("KID").title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (event.target.id == "MID") {
          document.getElementById("LID").tabIndex = event.target.tabIndex;
          document.getElementById("LID").focus();
          this.TabbingAlphabeticalFilter("LID");
          this.AlphabeticalValue = "LID";
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("LID").innerText, document.getElementById("LID").id, event.target.type, document.getElementById("LID").title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (event.target.id == "NID") {
          document.getElementById("MID").tabIndex = event.target.tabIndex;
          document.getElementById("MID").focus();
          this.TabbingAlphabeticalFilter("MID");
          this.AlphabeticalValue = "MID";
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("MID").innerText, document.getElementById("MID").id, event.target.type, document.getElementById("MID").title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (event.target.id == "OID") {
          document.getElementById("NID").tabIndex = event.target.tabIndex;
          document.getElementById("NID").focus();
          this.TabbingAlphabeticalFilter("NID");
          this.AlphabeticalValue = "NID";
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("NID").innerText, document.getElementById("NID").id, event.target.type, document.getElementById("NID").title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (event.target.id == "PID") {
          document.getElementById("OID").tabIndex = event.target.tabIndex;
          document.getElementById("OID").focus();
          this.TabbingAlphabeticalFilter("OID");
          this.AlphabeticalValue = "OID";
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("OID").innerText, document.getElementById("OID").id, event.target.type, document.getElementById("OID").title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (event.target.id == "QID") {
          document.getElementById("PID").focus();
          document.getElementById("PID").tabIndex = event.target.tabIndex;
          this.TabbingAlphabeticalFilter("PID");
          this.AlphabeticalValue = "PID";
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("PID").innerText, document.getElementById("PID").id, event.target.type, document.getElementById("PID").title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (event.target.id == "RID") {
          document.getElementById("QID").tabIndex = event.target.tabIndex;
          document.getElementById("QID").focus();
          this.TabbingAlphabeticalFilter("QID");
          this.AlphabeticalValue = "QID";
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("QID").innerText, document.getElementById("QID").id, event.target.type, document.getElementById("QID").title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (event.target.id == "SID") {
          document.getElementById("RID").tabIndex = event.target.tabIndex;
          document.getElementById("RID").focus();
          this.TabbingAlphabeticalFilter("RID");
          this.AlphabeticalValue = "RID";
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("RID").innerText, document.getElementById("RID").id, event.target.type, document.getElementById("RID").title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (event.target.id == "TID") {
          document.getElementById("SID").tabIndex = event.target.tabIndex;
          document.getElementById("SID").focus();
          this.TabbingAlphabeticalFilter("SID");
          this.AlphabeticalValue = "SID";
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("SID").innerText, document.getElementById("SID").id, event.target.type, document.getElementById("SID").title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (event.target.id == "UID") {
          document.getElementById("TID").tabIndex = event.target.tabIndex;
          document.getElementById("TID").focus();
          this.TabbingAlphabeticalFilter("TID");
          this.AlphabeticalValue = "TID";
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("TID").innerText, document.getElementById("TID").id, event.target.type, document.getElementById("TID").title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (event.target.id == "VID") {
          document.getElementById("UID").tabIndex = event.target.tabIndex;
          document.getElementById("UID").focus();
          this.TabbingAlphabeticalFilter("UID");
          this.AlphabeticalValue = "UID";
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("UID").innerText, document.getElementById("UID").id, event.target.type, document.getElementById("UID").title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (event.target.id == "WID") {
          document.getElementById("VID").tabIndex = event.target.tabIndex;
          document.getElementById("VID").focus();
          this.TabbingAlphabeticalFilter("VID");
          this.AlphabeticalValue = "VID";
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("VID").innerText, document.getElementById("VID").id, event.target.type, document.getElementById("VID").title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (event.target.id == "XID") {
          document.getElementById("WID").tabIndex = event.target.tabIndex;
          document.getElementById("WID").focus();
          this.TabbingAlphabeticalFilter("WID");
          this.AlphabeticalValue = "WID";
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("WID").innerText, document.getElementById("WID").id, event.target.type, document.getElementById("WID").title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (event.target.id == "YID") {
          document.getElementById("XID").tabIndex = event.target.tabIndex;
          document.getElementById("XID").focus();
          this.TabbingAlphabeticalFilter("XID");
          this.AlphabeticalValue = "XID";
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("XID").innerText, document.getElementById("XID").id, event.target.type, document.getElementById("XID").title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (event.target.id == "ZID") {
          document.getElementById("YID").tabIndex = event.target.tabIndex;
          document.getElementById("YID").focus();
          this.TabbingAlphabeticalFilter("YID");
          this.AlphabeticalValue = "YID";
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("YID").innerText, document.getElementById("YID").id, event.target.type, document.getElementById("YID").title, event.target.htmlFor, event.target.alt, event.key);
        }
      }
      else if (event.keyCode == 27) {
        //if (event.target.id == "tdAlerts" || event.target.id == "tdobligorDesc" || event.target.id == "tdwebcasts" || event.target.id == "tdOverview" || event.target.id == "tdHistory" || event.target.id == "tdQA") {
          document.getElementById("SkipMainContentfooter").focus();
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("SkipMainContentfooter").innerText, document.getElementById("SkipMainContentfooter").id, event.target.type, document.getElementById("SkipMainContentfooter").title, event.target.htmlFor, event.target.alt, event.key);
        //}
      }
      else if (event.keyCode == 32) {
         if (event.target.id == "btnClear" || event.target.id == "btnSearch") {         
          event.preventDefault();
          return;         
        }        
      }
      else if (event.keyCode == 13)//=========Enter 
      {
        debugger;
        if (event.target.id == "AID" || event.target.id == "BID" || event.target.id == "CID" || event.target.id == "DID" || event.target.id == "EID" || event.target.id == "FID" || event.target.id == "GID"
          || event.target.id == "HID" || event.target.id == "IID" || event.target.id == "JID" || event.target.id == "KID" || event.target.id == "LID" || event.target.id == "MID"
          || event.target.id == "NID" || event.target.id == "OID" || event.target.id == "PID" || event.target.id == "QID" || event.target.id == "RID" || event.target.id == "SID" || event.target.id == "TID"
          || event.target.id == "UID" || event.target.id == "VID" || event.target.id == "WID" || event.target.id == "XID" || event.target.id == "YID" || event.target.id == "ZID") {

          //var AlphabeticalValue = event.target.innerText;
          this.loadBrowseObligors(document.getElementById(event.target.id).innerText);
          //FontSizeSettingsBrowseObligor();
          //document.getElementById("pabeNoID").focus();
          //document.getElementById("pabeNoID").tabIndex = event.target.tabIndex;
          //BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("pabeNoID").innerText, document.getElementById("pabeNoID").id, event.target.type, document.getElementById("pabeNoID").title, event.target.htmlFor, event.target.alt, event.key);
        }
       
      }
      else if (event.keyCode == 16)//=============Shift + Tab Go
      {
        // add state column shift+tab function 
        if (event.target.id == "tdObligorState" || event.target.id == "tdobligorDesc" || event.target.id == "tdwebcasts" || event.target.id == "tdAlerts" || event.target.id == "tdOverview" || event.target.id == "tdHistory" || event.target.id == "tdQA") {
          document.getElementById("inputSuccess5").focus();
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("inputSuccess5").innerText, document.getElementById("inputSuccess5").id, event.target.type, document.getElementById("inputSuccess5").title, event.target.htmlFor, event.target.alt, event.key);
        }
      }

      else if (event.keyCode == 9) {

        if (event.target.id == "tdobligorDesc") {
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, event.target.innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
        }
        //No Records found in table then voice and caption read No data available! 
        else if (event.target.id == "noData") {
          responsiveVoiceSpeak("", "No data available!" + ". Use escape key to exit the table and go to footer.");
          
        }
        else {
          if (event.keyCode == 9) {
            BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, event.target.innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
          }
        }
      }
      else {
        if (event.keyCode == 9) {
          if (event.target.id == "liID") {
            document.getElementById("AID").focus();
            document.getElementById("AID").tabIndex = event.target.tabIndex;
            BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("AID").innerText, document.getElementById("AID").id, event.target.type, document.getElementById("AID").title, event.target.htmlFor, event.target.alt, event.key);
          }
        }
        else {
          debugger;
          //if (event.keyCode == 9) {
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, event.target.innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
          //}
        }
      }
    }
  };
  UpArrowKey(event: any, child_cell: string) {
    var parent_cell = $(event.target).index();
    $(event.target).parent().prev().children("td").eq(parent_cell).focus();
    if (event.target.id == "tdobligorDesc") {
      var innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[0].innerText;
      var title = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[0].title;
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, event.target.id, event.target.type, title, event.target.htmlFor, event.target.alt, event.key)
    }
    else if (event.target.id == "tdObligorState") {

      if ($(event.target).parent().prev().children("td").eq(child_cell).length == 0) {
        $('#hdlastRow').val('1');
      }
      else {
        $('#hdlastRow').val('0');
      }

      var innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[1].innerText;
      var title = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[1].title;
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, event.target.id, event.target.type, title, event.target.htmlFor, event.target.alt, event.key)
    }
  }
  DownArrowKey(event: any) {
    debugger;
    var innerText, title, child_cell = $(event.target).index();
    $(event.target).parent().next().children("td").eq(child_cell).focus();
    if (event.target.id == "tdobligorDesc") {
      if ($(event.target).parent().next().children("td").eq(child_cell).length != 0) {
        if ($(event.target).parent().next().next().children("td").eq(child_cell).length == 0) {
          $('#hdlastRow').val('1');
        }
        else {
          $('#hdlastRow').val('0');
        }

        innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[0].innerText;
        title = $(event.target).parent().next().children("td").eq(child_cell).prevObject[0].title;
        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key)
      }
    }
    else if (event.target.id == "tdObligorState") {
        if ($(event.target).parent().next().children("td").eq(child_cell).length != 0) {
        if ($(event.target).parent().next().next().children("td").eq(child_cell).length == 0) {
          $('#hdlastRow').val('1');
        }
        else {
          $('#hdlastRow').val('0');
        }
        innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[1].innerText;
        title = $(event.target).parent().next().children("td").eq(child_cell).prevObject[1].title;
        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, event.target.id, event.target.type, title, event.target.htmlFor, event.target.alt, event.key)
      }
    }
  }
  RightArrowKey(event: any, child_cell: string) {
    debugger;
    if (event.target.id == "tdobligorDesc") {
      var target = $(event.target).next();
      $(target).trigger('focus');
      if (target[0].id == "tdObligorState") {

        if ($(event.target).parent().next().children("td").eq(child_cell).length == 0) {
          $('#hdlastRow').val('1');
        }
        else {
          $('#hdlastRow').val('0');
        }
        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, target[0].innerText, target[0].id, event.target.type, target[0].title, event.target.htmlFor, event.target.alt, event.key)

      }
    }
    if (event.target.id == "tdObligorState") {
      var obligorDescIndex = 0;
      $(event.target).parent().next().children("td").eq(obligorDescIndex).focus();
      if (event.target.id == "tdObligorState") {
        if (typeof $(event.target).parent().next().children("td").eq(child_cell).prevObject[0] == "object") {
          var innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[0].innerText;
          var title = $(event.target).parent().next().children("td").eq(child_cell).prevObject[0].title;

          if ($(event.target).parent().next().children("td").eq(child_cell).length == 0) {
            $('#hdlastRow').val('1');
          }
          else {
            $('#hdlastRow').val('0');
          }
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, "tdobligorDesc", event.target.type, "", event.target.htmlFor, event.target.alt, event.key)
        }
      }
    }
  }
  LeftArrowKey(event: any, child_cell: string) {
    debugger;
    if (event.target.id == "tdObligorState") {
      var target = $(event.target).prev();
      $(target).trigger('focus');
      if (target[0].id == "tdobligorDesc") {
        if ($(event.target).parent().next().children("td").eq(child_cell).length == 0) {
          $('#hdlastRow').val('1');
        }
        else {
          $('#hdlastRow').val('0');
        }
        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, target[0].innerText, target[0].id, event.target.type, target[0].title, event.target.htmlFor, event.target.alt, event.key)
      }
    }
    if (event.target.id == "tdobligorDesc") {
      var obligorDescIndex = 1;
      $(event.target).parent().prev().children("td").eq(obligorDescIndex).focus();
      if (event.target.id == "tdobligorDesc") {
        if (typeof $(event.target).parent().prev().children("td").eq(child_cell).prevObject[1] == "object") {
          var innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[1].innerText;
          var title = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[1].title;
          $('#hdlastRow').val('0');
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, "tdObligorState", event.target.type, title, event.target.htmlFor, event.target.alt, event.key)
        }
      }
    }
  }
  // Correct tabbing on Alphabetical Filter
  TabbingAlphabeticalFilter(AlphabeticalChar: string) {
    debugger;
    document.getElementById("AID").tabIndex = -1;
    document.getElementById("BID").tabIndex = -1;
    document.getElementById("CID").tabIndex = -1;
    document.getElementById("DID").tabIndex = -1;
    document.getElementById("EID").tabIndex = -1;
    document.getElementById("FID").tabIndex = -1;
    document.getElementById("GID").tabIndex = -1;
    document.getElementById("HID").tabIndex = -1;
    document.getElementById("IID").tabIndex = -1;
    document.getElementById("JID").tabIndex = -1;
    document.getElementById("KID").tabIndex = -1;
    document.getElementById("LID").tabIndex = -1;
    document.getElementById("MID").tabIndex = -1;
    document.getElementById("NID").tabIndex = -1;
    document.getElementById("OID").tabIndex = -1;
    document.getElementById("PID").tabIndex = -1;
    document.getElementById("QID").tabIndex = -1;
    document.getElementById("RID").tabIndex = -1;
    document.getElementById("SID").tabIndex = -1;
    document.getElementById("TID").tabIndex = -1;
    document.getElementById("UID").tabIndex = -1;
    document.getElementById("VID").tabIndex = -1;
    document.getElementById("WID").tabIndex = -1;
    document.getElementById("XID").tabIndex = -1;
    document.getElementById("YID").tabIndex = -1;
    document.getElementById("ZID").tabIndex = -1;
    document.getElementById(AlphabeticalChar).tabIndex = 26;
  }
  onCancel() {   
    debugger;    
    //var x = event.keyCode;
    var inputSearch = <HTMLInputElement>document.getElementById("inputSuccess5");
    inputSearch.value = null;
  }
  onClick(obligorId, obligorDesc) {
    debugger;
    //Set value for obligorId and obligorDesc for all components.
    localStorage.clear();
    localStorage.OBLIGOR_ID = obligorId;
    localStorage.OBLIGOR_DESC = obligorDesc;
  }
  onClickFilingHistory(obligorId, obligorDesc) {
    debugger;
    //Set value for obligorId and obligorDesc for all components.
    //localStorage.clear();
    localStorage.OBLIGOR_ID = obligorId;
    localStorage.OBLIGOR_DESC = obligorDesc;    
  }  
  onChecked(e: Event, obligorId) {
    debugger;
    const checkbox = e.target as HTMLInputElement;
    var checkboxValue = checkbox.checked;
    this.sendInvestorAlert(obligorId, checkboxValue.toString());    
  }
  SearchObligors(event: any) {    
    debugger;
    
    //if (event.keycode != 32) {
      var SearchObligorValue = <HTMLInputElement>document.getElementById("inputSuccess5");
      //if (event.ctrlKey)
      this.loadSearchObligors(SearchObligorValue.value);
      //FontSizeSettingsBrowseObligor();
    //}
  }
  Alphabeticalclick(event: any) {
    debugger;
    var AlphabeticalValue = event.target.innerText;
    this.loadBrowseObligors(AlphabeticalValue);
    //FontSizeSettingsBrowseObligor();
  }
  ngOnInit() {
    debugger;
    var btnSearch = <HTMLButtonElement>document.getElementById("btnSearch");
    btnSearch.disabled = true;

    //document.getElementById("BrowseObligorPage").style.display = "none";
    //=========Caption Hide Show=============//
    if ($('#hidglbVarOnOff').val() == "OFF") {
      $('#captionhideshow').hide();
      $('#btnOnOff').val('OFF')
    }
    else {
      $('#captionhideshow').show();
      $('#btnOnOff').val('ON')
    }
    //============Voice Annotation On/Off=========
    if ($('#hidVoiceOnOff').val() == "OFF") {
      $('#btnVoiceAnnotation').val('OFF');
      $('#hidVoiceOnOff').val('OFF');
      $('#btnPlayPause').css('display', 'none');
    }
    else {
      $('#btnVoiceAnnotation').val('ON');
      $('#hidVoiceOnOff').val('ON');
      $('#btnPlayPause').css('display', 'block');
    }

    responsiveVoiceSpeak("", "This is Browse Obligror page. Use tab to go to the next field.");    
  }

  setFontSizeSettings() {
    if (IsLoadFontSizeSettings == 1) {
      FontSizeSettings();
      IsLoadFontSizeSettings = 0;
    }
  }
  MagnifieronDynamicChecking() {
    FontSizeSettings();
  }
  //public allBrowseobligor: Browseobligor;

  //Search obligors
  loadSearchObligors(SearchObligorsValue: string) {
    debugger;
    document.getElementById("overlay").style.display = "block";
    this.browseobligorService.GetDataSearchObligors(SearchObligorsValue).subscribe(data => {
      document.getElementById("overlay").style.display = "none";
      debugger;
      if (data['length'] == 0) {
        voiceForObligorNoFound();
        this.allBrowseobligor = data;
        
      }
      if (data['length'] > 0) {
        this.allBrowseobligor = data;
        voiceForObligorCount(data['length']);
        IsLoadFontSizeSettings = 1;
       
        //document.getElementById("pagingDiv").style.display = "block";
      }
      //else { document.getElementById("pagingDiv").style.display = "none"; }
    });

    this.MagnifieronDynamicChecking();
  }

  loadBrowseObligors(AlphabeticalChar: string) {
    debugger;
    document.getElementById("overlay").style.display = "block";
    this.browseobligorService.GetIssuerBrowseObligors(AlphabeticalChar).subscribe(data => {
      document.getElementById("overlay").style.display = "none";
   // this.browseobligorService.GetInvestorBrowseObligors(AlphabeticalChar).subscribe(data => {
      debugger;
      if (data['length'] == 0) {
        voiceForObligorNoFound();
        IsLoadFontSizeSettings = 0;
      }
      if (data['length'] > 0) {
        this.allBrowseobligor = data;
        voiceForObligorCount(data['length']);
        IsLoadFontSizeSettings = 1;
        
        //document.getElementById("pagingDiv").style.display = "block";
      }
      //else { document.getElementById("pagingDiv").style.display = "none";}
    });
    this.MagnifieronDynamicChecking();
  }

  OpenComplaince_Review(event: any, obligorId: string, ObligorDesc: string): void {
    debugger;
    localStorage.setItem("OBLIGOR_ID", obligorId);
   // localStorage.setItem("Page_Navigation", "AD");
    this.router.navigate(['/compliance-review']);
  }

  sendInvestorAlert(obligorId: string, enableAlert: string) {
    debugger;
    this.browseobligorService.SendAlerts(obligorId, enableAlert).subscribe(data => {
    });
  }

}

